module.exports = __webpack_public_path__ + "media/bom/mouser-577fe6df.png";